import { lazy as i } from "react";
function o(r) {
  return i(async () => ({ default: (await r()).default }));
}
const c = {
  TameeniLogoAR: o(async () => import("./brand/tameeni-logo-ar.svg.js")),
  TameeniLogoEN: o(async () => import("./brand/tameeni-logo-en.svg.js")),
  TameeniLogoIcon: o(async () => import("./brand/tameeni-logo-icon.svg.js")),
  IALogo: o(async () => import("./brand/ia-logo.svg.js")),
  RasanLogo: o(async () => import("./brand/rasan.svg.js"))
}, s = {
  Motor: o(async () => import("./products/motor.svg.js")),
  MotorColored: o(async () => import("./products/motor-colored.svg.js")),
  Health: o(async () => import("./products/health.svg.js")),
  HealthColored: o(async () => import("./products/health-colored.svg.js")),
  MMP: o(async () => import("./products/mmp.svg.js")),
  MMPColored: o(async () => import("./products/mmp-colored.svg.js")),
  Travel: o(async () => import("./products/travel.svg.js")),
  TravelColored: o(async () => import("./products/travel-colored.svg.js")),
  Home: o(async () => import("./products/home.svg.js")),
  HomeColored: o(async () => import("./products/home-colored.svg.js")),
  Life: o(async () => import("./products/life.svg.js")),
  LifeColored: o(async () => import("./products/life-colored.svg.js")),
  Marine: o(async () => import("./products/marine.svg.js")),
  MarineColored: o(async () => import("./products/marine-colored.svg.js")),
  Fleet: o(async () => import("./products/fleet.svg.js")),
  FleetColored: o(async () => import("./products/fleet-colored.svg.js")),
  Corporate: o(async () => import("./products/corporate.svg.js")),
  CorporateColored: o(
    async () => import("./products/corporate-colored.svg.js")
  ),
  Link: o(async () => import("./products/link-arrow.svg.js")),
  LinkColored: o(async () => import("./products/link-arrow-colored.svg.js")),
  MotorVertical: o(async () => import("./products/motor-art.svg.js")),
  HealthVertical: o(async () => import("./products/health-art.svg.js")),
  MMPVertical: o(async () => import("./products/mmp-art.svg.js")),
  TravelVertical: o(async () => import("./products/travel-art.svg.js")),
  MarineVertical: o(async () => import("./products/marine-art.svg.js")),
  HomeVertical: o(async () => import("./products/home-art.svg.js")),
  HealthSme: o(async () => import("./products/health-sme.svg.js")),
  HealthCorporate: o(async () => import("./products/health-corporate.svg.js")),
  DomesticHelper: o(async () => import("./products/domestic-helper.svg.js"))
}, e = {
  Appstore: o(async () => import("./mobile-app/app-store.svg.js")),
  GooglePlay: o(async () => import("./mobile-app/play-store.svg.js")),
  AppGallery: o(async () => import("./mobile-app/app-gallery.svg.js")),
  DownloadAppAfter: o(
    async () => import("./mobile-app/download-app-after.svg.js")
  ),
  DownloadAppBefore: o(
    async () => import("./mobile-app/download-app-before.svg.js")
  )
}, m = {
  Apartment: o(async () => import("./general/apartment.svg.js")),
  ArrowLeft: o(async () => import("./general/arrow-left.svg.js")),
  ArrowDown: o(async () => import("./general/arrow-down.svg.js")),
  ArrowRight: o(async () => import("./general/arrow-right.svg.js")),
  BuildingAndContent: o(
    async () => import("./general/building-and-content.svg.js")
  ),
  Building: o(async () => import("./general/building.svg.js")),
  Calendar: o(async () => import("./general/calendar.svg.js")),
  CheckCircle: o(async () => import("./general/check-circle.svg.js")),
  Checked: o(async () => import("./general/checked.svg.js")),
  ChevronDown: o(async () => import("./general/chevron-down.svg.js")),
  Chevron: o(async () => import("./general/chevron.svg.js")),
  Clock: o(async () => import("./general/clock.svg.js")),
  Close: o(async () => import("./general/close.svg.js")),
  CloudUpload: o(async () => import("./general/cloud-upload.svg.js")),
  Compare: o(async () => import("./general/compare.svg.js")),
  Content: o(async () => import("./general/content.svg.js")),
  Delete: o(async () => import("./general/delete.svg.js")),
  EyeHidden: o(async () => import("./general/eye-hidden.svg.js")),
  Eye: o(async () => import("./general/eye.svg.js")),
  Hamburger: o(async () => import("./general/Hamburger.svg.js")),
  Info: o(async () => import("./general/info.svg.js")),
  Language: o(async () => import("./general/language.svg.js")),
  LayoutList: o(async () => import("./general/layout-list.svg.js")),
  LayoutNavbar: o(async () => import("./general/layout-navbar.svg.js")),
  LinkArrow: o(async () => import("./general/link-arrow.svg.js")),
  Login: o(async () => import("./general/login.svg.js")),
  Logout: o(async () => import("./general/logout.svg.js")),
  Minus: o(async () => import("./general/minus.svg.js")),
  MultiStoryBuilding: o(
    async () => import("./general/multi-story-building.svg.js")
  ),
  Play: o(async () => import("./general/play.svg.js")),
  ProfileDropDown: o(async () => import("./general/profile-dropdown.svg.js")),
  questionCircle: o(async () => import("./general/question-circle.svg.js")),
  RefreshRotate: o(async () => import("./general/refresh-rotate.svg.js")),
  Settings: o(async () => import("./general/settings.svg.js")),
  TimeClock: o(async () => import("./general/time-clock.svg.js")),
  Timeout: o(async () => import("./general/timeout.svg.js")),
  User: o(async () => import("./general/user.svg.js")),
  Villa: o(async () => import("./general/villa.svg.js")),
  WrongCircle: o(async () => import("./general/wrong-circle.svg.js")),
  SaudiRiyalSymbol: o(
    async () => import("./general/saudi-riyal-symbol.svg.js")
  ),
  Plus: o(async () => import("./general/plus.svg.js")),
  Share: o(async () => import("./general/share.svg.js")),
  Analytics: o(async () => import("./general/analytics.svg.js")),
  CarCircle: o(async () => import("./general/car-circle.svg.js")),
  Repair: o(async () => import("./general/repair.svg.js")),
  Bundle: o(async () => import("./general/bundle.svg.js")),
  Filter: o(async () => import("./general/filter.svg.js")),
  SortArrow: o(async () => import("./general/sort-arrows.svg.js")),
  AddCircle: o(async () => import("./general/add-circle.svg.js")),
  CheckDone: o(async () => import("./general/check-done.svg.js")),
  EditPen: o(async () => import("./general/edit-pen.svg.js")),
  UserAvatar: o(async () => import("./general/user-avatar.svg.js")),
  Trash: o(async () => import("./general/trash.svg.js")),
  MinusCircle: o(async () => import("./general/minus-circle.svg.js"))
}, p = {
  calculatorBill: o(async () => import("./info/calculator-bill.svg.js")),
  Completed: o(async () => import("./info/completed.svg.js")),
  Duplicate: o(async () => import("./info/duplicate.svg.js")),
  FirstMedal: o(async () => import("./info/first-medal.svg.js")),
  LegalCase: o(async () => import("./info/legal-case.svg.js")),
  Transparency: o(async () => import("./info/transparency.svg.js"))
}, y = {
  Facebook: o(async () => import("./social/facebook.svg.js")),
  Instagram: o(async () => import("./social/instagram.svg.js")),
  Snapchat: o(async () => import("./social/snapchat.svg.js")),
  Whatsapp: o(async () => import("./social/whatsapp.svg.js")),
  Youtube: o(async () => import("./social/youtube.svg.js")),
  XLogo: o(async () => import("./social/x-logo.svg.js"))
}, l = {
  RatingVectorBlue: o(async () => import("./home/feedback-vector-blue.svg.js")),
  RatingVectorGreen: o(
    async () => import("./home/feedback-vector-green.svg.js")
  ),
  QitafLogo: o(async () => import("./home/qitaf-logo.svg.js")),
  GoogleLogo: o(async () => import("./home/google-logo.svg.js")),
  Star: o(async () => import("./home/star.svg.js")),
  SelfService: o(async () => import("./home/self-service.svg.js")),
  Discount: o(async () => import("./home/discount.svg.js")),
  ShipmentSectionVector: o(
    async () => import("./home/shipment-section-vector.svg.js")
  )
}, I = {
  mbi: o(async () => import("./motor/mbi.svg.js")),
  mojaz: o(async () => import("./motor/mojaz.svg.js")),
  NewInsurance: o(async () => import("./motor/new-insurance.svg.js")),
  BuyCar: o(async () => import("./motor/buy-car.svg.js")),
  ImportCar: o(async () => import("./motor/import-car.svg.js")),
  firstMedal: o(async () => import("./motor/firt-medal.svg.js")),
  discountTag: o(async () => import("./motor/discount-tag.svg.js")),
  transparency: o(async () => import("./motor/transparency.svg.js")),
  legal: o(async () => import("./motor/legal.svg.js")),
  offersRange: o(async () => import("./motor/offers.svg.js")),
  pricing: o(async () => import("./motor/pricing.svg.js"))
}, g = {
  classes: o(async () => import("./health-sme/classes.svg.js")),
  compare: o(async () => import("./health-sme/compare.svg.js")),
  detailedInfo: o(async () => import("./health-sme/details.svg.js")),
  providersList: o(async () => import("./health-sme/providers-list.svg.js")),
  saveTime: o(async () => import("./health-sme/save-time.svg.js")),
  cchiUpload: o(async () => import("./health-sme/upload.svg.js"))
}, C = {
  mmpBest: o(async () => import("./mmp/mmp-best.svg.js")),
  mmpQuotelist: o(async () => import("./mmp/mmp-quotelist.svg.js")),
  mmpVisitors: o(async () => import("./mmp/mmp-visitors.svg.js")),
  mmpDeclarations: o(async () => import("./mmp/mp-declarations.svg.js")),
  mmpVerification: o(async () => import("./mmp/mp-verification.svg.js")),
  mmpClearSpecialties: o(async () => import("./mmp/clear-specialities.svg.js"))
}, u = {
  HealthSME: o(async () => import("./health/sme.svg.js")),
  Domestic: o(async () => import("./health/domestic.svg.js")),
  PremiumResidency: o(async () => import("./health/premium-residency.svg.js")),
  HealthCustomerSupport: o(
    async () => import("./health/customer-support.svg.js")
  ),
  HealthCoverage: o(
    async () => import("./health/customizable-coverage.svg.js")
  ),
  HealthPrices: o(
    async () => import("./health/health-affordable-prices.svg.js")
  ),
  HealthCompare: o(async () => import("./health/health-compare-plans.svg.js")),
  HealthProcess: o(async () => import("./health/health-quick-process.svg.js")),
  HealthProviders: o(
    async () => import("./health/providers-wide-selection.svg.js")
  ),
  HealthComprehensiveCoverage: o(
    async () => import("./health/comprehensive-coverage.svg.js")
  ),
  HealthEmployerRelation: o(
    async () => import("./health/employer-relationship.svg.js")
  ),
  HealthFinancialProtect: o(
    async () => import("./health/financial-protection.svg.js")
  ),
  HealthImmediateCare: o(async () => import("./health/immediate-care.svg.js")),
  HealthPeaceOfMind: o(async () => import("./health/peace-mind.svg.js")),
  HealthQuality: o(async () => import("./health/quality-healthcare.svg.js"))
}, d = {
  TravelBusiness: o(async () => import("./travel/travel-business.svg.js")),
  TravelLeisure: o(async () => import("./travel/travel-leisure.svg.js")),
  TravelStudy: o(async () => import("./travel/travel-study.svg.js")),
  TravelResponse: o(async () => import("./travel/immediate-response.svg.js")),
  TravelCoverage: o(async () => import("./travel/needs-coverage.svg.js")),
  TravelBest: o(async () => import("./travel/best-practice-travel.svg.js")),
  TravelOffers: o(async () => import("./travel/tameeni-offers.svg.js")),
  TravelVerifications: o(
    async () => import("./travel/travel-verification.svg.js")
  ),
  TravelQuotelist: o(async () => import("./travel/travel-quotelist.svg.js"))
}, L = {
  PsBenefitAlert: o(async () => import("./ps/benefit-alert.svg.js")),
  PsBenefitCompare: o(async () => import("./ps/benefit-compare.svg.js")),
  PsBenefitIssue: o(async () => import("./ps/benefit-issue.svg.js")),
  PsBenefitMonitor: o(async () => import("./ps/benefit-monitor.svg.js")),
  PsBenefitPayment: o(async () => import("./ps/benefit-payment.svg.js")),
  PsBenefitProgram: o(async () => import("./ps/benefit-program.svg.js")),
  PsBenefitProtection: o(async () => import("./ps/benefit-protection.svg.js")),
  PsBenefitStrategy: o(async () => import("./ps/benefit-strategy.svg.js")),
  PsOptionEducation: o(async () => import("./ps/option-education.svg.js")),
  PsOptionInvestment: o(async () => import("./ps/option-investment.svg.js")),
  PsOptionMarriage: o(async () => import("./ps/option-marriage.svg.js")),
  PsOptionRetirement: o(async () => import("./ps/option-retirement.svg.js"))
}, f = {
  FleetPricingIcon1: o(async () => import("./fleet/pricing-icon1.svg.js")),
  FleetPricingIcon2: o(async () => import("./fleet/pricing-icon2.svg.js")),
  FleetPricingIcon3: o(async () => import("./fleet/pricing-icon3.svg.js")),
  FleetPricingIcon4: o(async () => import("./fleet/pricing-icon4.svg.js")),
  FleetPricingIcon5: o(async () => import("./fleet/pricing-icon5.svg.js"))
}, h = {
  PremiumResidencySmallCardMobile: o(
    async () => import("./premium-residency/small-card-mobile.svg.js")
  ),
  PremiumResidencySmallCardWeb: o(
    async () => import("./premium-residency/small-card-web.svg.js")
  )
}, t = {
  GulfUnionLogo: o(async () => import("./ics/logos/gulf-union.logo.svg.js")),
  MalathLogo: o(async () => import("./ics/logos/malath.logo.svg.js")),
  AICCLogo: o(async () => import("./ics/logos/aicc.logo.svg.js")),
  walaaLogo: o(async () => import("./ics/logos/walaa.logo.svg.js")),
  Der3Logo: o(async () => import("./ics/logos/der3.logo.svg.js")),
  ACIGLogo: o(async () => import("./ics/logos/acig.logo.svg.js")),
  SalamaLogo: o(async () => import("./ics/logos/salama.logo.svg.js")),
  mutakamelaLogo: o(async () => import("./ics/logos/mutakamela.logo.svg.js")),
  GGCICLogo: o(async () => import("./ics/logos/ggcic.logo.svg.js")),
  TUCILogo: o(async () => import("./ics/logos/tuci.logo.svg.js")),
  AJTLogo: o(async () => import("./ics/logos/ajt.logo.svg.js")),
  MedgulfLogo: o(async () => import("./ics/logos/medgulf.logo.svg.js")),
  UCALogo: o(async () => import("./ics/logos/uca.logo.svg.js")),
  WICLogo: o(async () => import("./ics/logos/wic.logo.svg.js")),
  TawuniyaLogo: o(async () => import("./ics/logos/tawuniya.logo.svg.js")),
  ARTLogo: o(async () => import("./ics/logos/art.logo.svg.js")),
  AlSagrLogo: o(async () => import("./ics/logos/al-sagr.logo.svg.js")),
  ATMCLogo: o(async () => import("./ics/logos/atmc.logo.svg.js")),
  ACILogo: o(async () => import("./ics/logos/aci.logo.svg.js")),
  GIGLogo: o(async () => import("./ics/logos/gig.logo.svg.js")),
  LivaLogo: o(async () => import("./ics/logos/liva.logo.svg.js")),
  BurujLogo: o(async () => import("./ics/logos/buruj.logo.svg.js")),
  TreeLogo: o(async () => import("./ics/logos/tree.logo.svg.js"))
}, n = {
  GulfUnionIcon: o(async () => import("./ics/icons/gulf-union.icon.svg.js")),
  MalathIcon: o(async () => import("./ics/icons/malath.icon.svg.js")),
  AICCIcon: o(async () => import("./ics/icons/aicc.icon.svg.js")),
  walaaIcon: o(async () => import("./ics/icons/walaa.icon.svg.js")),
  Der3Icon: o(async () => import("./ics/icons/der3.icon.svg.js")),
  ACIGIcon: o(async () => import("./ics/icons/acig.icon.svg.js")),
  SalamaIcon: o(async () => import("./ics/icons/salama.icon.svg.js")),
  mutakamelaIcon: o(async () => import("./ics/icons/mutakamela.icon.svg.js")),
  GGCICIcon: o(async () => import("./ics/icons/ggcic.icon.svg.js")),
  TUCIIcon: o(async () => import("./ics/icons/tuci.icon.svg.js")),
  AJTIcon: o(async () => import("./ics/icons/ajt.icon.svg.js")),
  MedgulfIcon: o(async () => import("./ics/icons/medgulf.icon.svg.js")),
  UCAIcon: o(async () => import("./ics/icons/uca.icon.svg.js")),
  WICIcon: o(async () => import("./ics/icons/wic.icon.svg.js")),
  TawuniyaIcon: o(async () => import("./ics/icons/tawuniya.icon.svg.js")),
  ARTIcon: o(async () => import("./ics/icons/art.icon.svg.js")),
  AlSagrIcon: o(async () => import("./ics/icons/al-sagr.icon.svg.js")),
  ATMCIcon: o(async () => import("./ics/icons/atmc.icon.svg.js")),
  ACIIcon: o(async () => import("./ics/icons/aci.icon.svg.js")),
  GIGIcon: o(async () => import("./ics/icons/gig.icon.svg.js")),
  LivaIcon: o(async () => import("./ics/icons/liva.icon.svg.js")),
  BurujIcon: o(async () => import("./ics/icons/buruj.icon.svg.js")),
  TreeIcon: o(async () => import("./ics/icons/tree.icon.svg.js"))
}, a = {
  IA: import("./sponsors/ia.png.js"),
  Monshaat: import("./sponsors/monshaat.png.js"),
  Mazaya: import("./sponsors/mazaya.png.js")
}, P = {
  ...c,
  ...s,
  ...e,
  ...m,
  ...p,
  ...y,
  ...l,
  ...I,
  ...u,
  ...g,
  ...C,
  ...d,
  ...L,
  ...f,
  ...h,
  ...t,
  ...n,
  ...a
}, S = Object.keys(P), T = Object.keys({ ...a }), v = Object.keys(n), H = Object.keys(t), B = Object.keys(a);
export {
  S as IconsKeys,
  T as ImageKeys,
  C as MMPSpecificIcons,
  P as default,
  f as fleetSpecificIcons,
  m as generalIcons,
  g as healthSMESpecificIcons,
  u as healthSpecificIcons,
  l as homepageIcons,
  v as icIconKeys,
  H as icLogoKeys,
  n as icsIcons,
  t as icsLogos,
  e as mobileAppIcons,
  I as motorSpecificIcons,
  h as premiumResidencySpecificIcons,
  L as psSpecificIcons,
  y as socialIcons,
  B as sponsorsKeys,
  a as sponsorsLogos,
  c as tameeniBrandIcons,
  p as tameeniInfoIcons,
  s as tameeniProductIcons,
  d as travelSpecificIcons
};
//# sourceMappingURL=index.js.map
